import { Box, TextField, Typography } from "@mui/material";
import React from "react";
import { useParams } from "react-router-dom";

import RegionAPI from "../api/Region.api";
import BasicShowEdit from "../components/BasicShowEdit";
import Layout from "../components/Layout";
import { Region, RegionInput } from "../types";

export default function RegionShow() {
  const { id } = useParams();
  const { data: region } = RegionAPI.useDetail(id);

  return (
    <Layout>
      <Box
        sx={{
          display: "flex",
          flexGrow: 1,
          flexDirection: "column",
          gap: "1rem",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h2">Regions</Typography>
        </Box>

        {region && <RegionForm region={region} />}
      </Box>
    </Layout>
  );
}

function RegionForm({ region }: { region: Region }) {
  const [name, setName] = React.useState<string>(region.name);

  const input: RegionInput = {
    ...region,
    name,
  };

  return (
    <BasicShowEdit
      modelApiUseSave={RegionAPI.useSave}
      modelApiUseDelete={RegionAPI.useDelete}
      modelInput={input}
    >
      <TextField
        label="Name"
        value={name}
        onChange={(event) => setName(event.target.value)}
      />
    </BasicShowEdit>
  );
}
